import { render, staticRenderFns } from "./flexLayoutMV.vue?vue&type=template&id=4cf1da83&"
import script from "./flexLayoutMV.vue?vue&type=script&lang=js&"
export * from "./flexLayoutMV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports